export const PASSWORD_MIN_LENGTH = 12;
export const PASSWORD_MAX_LENGTH = 128;

export type PasswordSetupState = {
  longEnough: boolean;
  confirmationStarted: boolean;
  matches: boolean;
  ready: boolean;
};

export function passwordSetupState(password: string, confirmation: string): PasswordSetupState {
  const longEnough = password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH;
  const confirmationStarted = confirmation.length > 0;
  const matches = confirmationStarted && password === confirmation;
  return { longEnough, confirmationStarted, matches, ready: longEnough && matches };
}
